<script setup lang="ts">
// 守狸吉祥物（与营销站 keytail-www 同款）：正面趴伏的鼬/貂类小兽——横跨双眼的深色眼罩斑纹
// + 米色前突长吻 + 两侧低位小耳 + 低伏长身，貂科识别明确（不是熊）；大眼带高光、软萌友善，
// 小金钥匙在前爪边点缀。色值取自守狸皮肤色板（守狸棕 / 钥匙金 / 深巢栗 / 守光米）。
defineProps<{ size?: number }>();
</script>

<template>
  <svg
    class="kt-mascot"
    :width="size ?? 40"
    :height="size ?? 40"
    viewBox="0 0 120 120"
    fill="none"
    role="img"
    aria-label="守狸吉祥物"
  >
    <g stroke-linecap="round" stroke-linejoin="round">
      <path d="M18 76C20 61 35 53 57 56C80 58 99 64 105 76C111 88 98 99 75 100C52 101 29 94 21 85C18 82 17 79 18 76Z" fill="#B36A3E" stroke="#3A2B22" stroke-width="4"/>
      <path d="M28 78C39 68 58 65 80 70C91 72 99 77 104 82" fill="none" stroke="#C98759" stroke-width="5"/>
      <path d="M37 89C49 95 72 96 91 90" fill="none" stroke="#F4EDDF" stroke-width="5"/>

      <path d="M35 47C27 47 23 42 25 36C30 32 38 36 40 43Z" fill="#B36A3E" stroke="#3A2B22" stroke-width="4"/>
      <path d="M85 43C88 36 96 32 101 36C103 42 99 47 91 47Z" fill="#B36A3E" stroke="#3A2B22" stroke-width="4"/>
      <path d="M32 40C35 39 37 41 38 44C35 44 32 43 30 40Z" fill="#C98759"/>
      <path d="M88 44C89 41 92 39 95 40C93 43 90 44 88 44Z" fill="#C98759"/>

      <path d="M32 55C30 41 41 31 59 29C78 28 90 39 88 54C86 69 74 77 60 77C45 77 34 69 32 55Z" fill="#B36A3E" stroke="#3A2B22" stroke-width="4"/>
      <path d="M38 48C43 38 52 34 61 34C72 34 81 40 85 49C80 57 70 60 60 59C50 59 42 56 38 48Z" fill="#3A2B22"/>
      <ellipse cx="50" cy="48" rx="5" ry="6" fill="#F4EDDF"/>
      <ellipse cx="70" cy="48" rx="5" ry="6" fill="#F4EDDF"/>
      <circle cx="51" cy="49" r="3.1" fill="#3A2B22"/>
      <circle cx="69" cy="49" r="3.1" fill="#3A2B22"/>
      <circle cx="52" cy="46" r="1.2" fill="#F4EDDF"/>
      <circle cx="70" cy="46" r="1.2" fill="#F4EDDF"/>
      <path d="M49 52C51 45 69 45 72 52C74 62 68 71 60 72C52 71 46 62 49 52Z" fill="#F4EDDF"/>
      <path d="M55 54C58 51 63 51 66 54C64 58 58 58 55 54Z" fill="#3A2B22"/>
      <path d="M60 58C59 62 56 64 52 65" fill="none" stroke="#3A2B22" stroke-width="2.5"/>
      <path d="M60 58C61 62 64 64 68 65" fill="none" stroke="#3A2B22" stroke-width="2.5"/>
      <path d="M44 38C49 34 56 32 63 33" fill="none" stroke="#C98759" stroke-width="4"/>

      <path d="M37 79C45 75 52 77 56 84C53 91 42 91 36 87C34 84 35 81 37 79Z" fill="#B36A3E" stroke="#3A2B22" stroke-width="4"/>
      <path d="M74 84C78 77 86 75 93 79C95 82 95 86 92 88C85 92 77 91 74 84Z" fill="#B36A3E" stroke="#3A2B22" stroke-width="4"/>
      <path d="M42 86C45 84 49 84 52 87" fill="none" stroke="#3A2B22" stroke-width="2.5"/>
      <path d="M80 87C83 84 87 84 90 86" fill="none" stroke="#3A2B22" stroke-width="2.5"/>

      <g transform="rotate(-12 93 86)">
        <path d="M83 86A4.5 4.5 0 1 0 92 86H103V82H107V78H103V75H92A4.5 4.5 0 0 0 83 86ZM86 86A1.7 1.7 0 1 1 89.4 86A1.7 1.7 0 0 1 86 86Z" fill="#D4A357" fill-rule="evenodd" stroke="#3A2B22" stroke-width="2.5"/>
      </g>
    </g>
  </svg>
</template>

<style scoped>
.kt-mascot {
  display: inline-block;
  vertical-align: middle;
}
</style>
